import type {FC} from 'react'
import {Button, Modal, Spinner} from 'react-bootstrap'

export interface SsoRoleOption {
  role: string
  email: string
  name: string
}

interface RoleSelectModalProps {
  show: boolean
  roles: SsoRoleOption[]
  pendingRole: string | null
  onSelect: (role: string) => void
  onCancel: () => void
}

const formatRole = (role: string) =>
  role
    .toLowerCase()
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')

const RoleSelectModal: FC<RoleSelectModalProps> = ({
  show,
  roles,
  pendingRole,
  onSelect,
  onCancel,
}) => {
  const busy = pendingRole !== null

  return (
    <Modal show={show} onHide={() => !busy && onCancel()} centered backdrop='static'>
      <Modal.Header style={{border: 'none'}}>
        <div>
          <Modal.Title>Continue as</Modal.Title>
          <div className='text-muted fs-7 mt-1'>Choose which role you want to sign in as.</div>
        </div>
      </Modal.Header>
      <Modal.Body className='d-grid gap-2'>
        {roles.length === 0 && (
          <p className='text-muted mb-0'>No default users are configured for any role.</p>
        )}
        {roles.map((option) => (
          <Button
            key={option.role}
            variant='outline-primary'
            className='d-flex justify-content-between align-items-center text-start py-3'
            disabled={busy}
            onClick={() => onSelect(option.role)}
          >
            <span className='d-flex flex-column'>
              <span className='fw-semibold'>{formatRole(option.role)}</span>
              <small className='opacity-75'>
                {option.name ? `${option.name} · ` : ''}
                {option.email}
              </small>
            </span>
            {pendingRole === option.role && <Spinner animation='border' size='sm' />}
          </Button>
        ))}
      </Modal.Body>
      <Modal.Footer style={{border: 'none'}}>
        <Button variant='link' onClick={onCancel} disabled={busy}>
          Back to sign in
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default RoleSelectModal
